export default __webpack_public_path__ + "static/media/frog-jump.21a080e9.png";